module.exports = __webpack_public_path__ + "static/media/36-4.6c9dd94d.mp3";